// extracted by mini-css-extract-plugin
export default {"page":"G1-z","cartModal":"H1-z","checkout":"I1-z","placeholder":"J1-z","account":"K1-z"};